import { render } from '@react-three/offscreen'
import Scene from './Scene/Scene'

// Now render the scene
render(<Scene isWorker={true} />)
